import React from "react";
import { cn } from "../../lib/utils";

export function Home01({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      className={cn('h-4 w-4', className)}
      {...props}
    >
      <title>home-01</title>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 10.5651C3 9.99071 3 9.70353 3.07403 9.43907C3.1396 9.2048 3.24737 8.98446 3.39203 8.78887C3.55534 8.56807 3.78202 8.39176 4.23539 8.03914L11.0177 2.76401C11.369 2.49076 11.5447 2.35413 11.7387 2.30162C11.9098 2.25528 12.0902 2.25528 12.2613 2.30162C12.4553 2.35413 12.631 2.49076 12.9823 2.76401L19.7646 8.03914C20.218 8.39176 20.4447 8.56807 20.608 8.78887C20.7526 8.98446 20.8604 9.2048 20.926 9.43907C21 9.70353 21 9.99071 21 10.5651V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V10.5651Z"/>
    </svg>
  )
}
